/*
 * @Descripttion:
 * @version:
 * @Author: gaochen
 * @Date: 2021-09-24 16:54:25
 * @LastEditors: gaochen
 * @LastEditTime: 2021-09-24 18:19:22
 */
import Vue from 'vue'
import { ImagePreview } from 'vant'
Vue.directive('preview', {
  // binding.value 需要传入一个对象
  // {
  //   images: [],
  //   startPosition: 1
  // }
  inserted(el, binding) {
    el.addEventListener('click', () => {
      console.log(binding)
      ImagePreview(binding.value)
    })
  }
})
